/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */

/**
 * ###
 * ___
 * Function that generates time values in Hours ( 12-Hour and  24-Hour) , Minutes and Seconds
 * ___
 * #### How to use this function ?
 * Import like this in the component:
 *
 * ```js
 * import { TwelveHourValues , TwentyFourHourValues, MinuteValues , SecondValues , AmPmValues } from './utils/time-value-generator'
 * ```
 * Then use the function like the following:
 *
 * ```js
 * var hourValues = TwelveHourValues();
 * ```
 *
 */
import { prependZero } from './number-formatter.js';

export const TwelveHourValues = () => {
  let hourValues = [];
  for (let i = 1; i <= 12; i++) {
    hourValues.push(prependZero(parseInt(i, 10)).toString());
  }
  return hourValues;
};

export const TwentyFourHourValues = () => {
  let hourValues = [];
  for (let i = 0; i < 24; i++) {
    hourValues.push(prependZero(parseInt(i, 10)).toString());
  }
  return hourValues;
};

export const MinuteValues = () => {
  let minuteValues = [];
  for (let i = 0; i < 60; i++) {
    minuteValues.push(prependZero(parseInt(i, 10)).toString());
  }

  return minuteValues;
};

export const SecondValues = () => {
  let secondValues = [];
  for (let i = 0; i < 60; i++) {
    secondValues.push(prependZero(parseInt(i, 10)).toString());
  }

  return secondValues;
};

export const AmPmValues = () => {
  return ['AM', 'PM'];
};
